module.exports = __webpack_public_path__ + "static/media/pearsonFuelsLogoV2.6140bdc5.png";